/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HomeHealthCertificationSigner } from './HomeHealthCertificationSigner';
import {
    HomeHealthCertificationSignerFromJSON,
    HomeHealthCertificationSignerFromJSONTyped,
    HomeHealthCertificationSignerToJSON,
    HomeHealthCertificationSignerToJSONTyped,
} from './HomeHealthCertificationSigner';
import type { HomeHealthCertificationAttestation } from './HomeHealthCertificationAttestation';
import {
    HomeHealthCertificationAttestationFromJSON,
    HomeHealthCertificationAttestationFromJSONTyped,
    HomeHealthCertificationAttestationToJSON,
    HomeHealthCertificationAttestationToJSONTyped,
} from './HomeHealthCertificationAttestation';
import type { HomeHealthCertificationReference } from './HomeHealthCertificationReference';
import {
    HomeHealthCertificationReferenceFromJSON,
    HomeHealthCertificationReferenceFromJSONTyped,
    HomeHealthCertificationReferenceToJSON,
    HomeHealthCertificationReferenceToJSONTyped,
} from './HomeHealthCertificationReference';
import type { HomeHealthCertificationEvidence } from './HomeHealthCertificationEvidence';
import {
    HomeHealthCertificationEvidenceFromJSON,
    HomeHealthCertificationEvidenceFromJSONTyped,
    HomeHealthCertificationEvidenceToJSON,
    HomeHealthCertificationEvidenceToJSONTyped,
} from './HomeHealthCertificationEvidence';

/**
 * 
 * @export
 * @interface HomeHealthCertificationEncounterCandidate
 */
export interface HomeHealthCertificationEncounterCandidate {
    /**
     * 
     */
    document_name: string;
    /**
     * 
     */
    encounter_date: string;
    /**
     * 
     */
    encounter_ref: Array<HomeHealthCertificationReference>;
    /**
     * 
     */
    signers: Array<HomeHealthCertificationSigner>;
    /**
     * 
     */
    performer_type: HomeHealthCertificationEncounterCandidatePerformerTypeEnum;
    /**
     * 
     */
    setting: HomeHealthCertificationEncounterCandidateSettingEnum;
    /**
     * 
     */
    modality: HomeHealthCertificationEncounterCandidateModalityEnum;
    /**
     * 
     */
    related_to_hh_reason: HomeHealthCertificationAttestation;
    /**
     * 
     */
    signed: HomeHealthCertificationAttestation;
    /**
     * 
     */
    clinical_support: HomeHealthCertificationEvidence;
}


/**
 * @export
 */
export const HomeHealthCertificationEncounterCandidatePerformerTypeEnum = {
    Physician: 'physician',
    Np: 'np',
    Cns: 'cns',
    Pa: 'pa',
    Cnm: 'cnm',
    Rn: 'rn',
    Lpn: 'lpn',
    SocialWorker: 'social_worker',
    Pt: 'pt',
    Ot: 'ot',
    Slp: 'slp',
    Other: 'other',
    Unknown: 'unknown',
} as const;
export type HomeHealthCertificationEncounterCandidatePerformerTypeEnum = typeof HomeHealthCertificationEncounterCandidatePerformerTypeEnum[keyof typeof HomeHealthCertificationEncounterCandidatePerformerTypeEnum];

/**
 * @export
 */
export const HomeHealthCertificationEncounterCandidateSettingEnum = {
    Hospital: 'hospital',
    Office: 'office',
    Ed: 'ED',
    Snf: 'SNF',
    Specialist: 'specialist',
    Other: 'other',
    Unknown: 'unknown',
} as const;
export type HomeHealthCertificationEncounterCandidateSettingEnum = typeof HomeHealthCertificationEncounterCandidateSettingEnum[keyof typeof HomeHealthCertificationEncounterCandidateSettingEnum];

/**
 * @export
 */
export const HomeHealthCertificationEncounterCandidateModalityEnum = {
    InPerson: 'in_person',
    Telehealth: 'telehealth',
    Unknown: 'unknown',
} as const;
export type HomeHealthCertificationEncounterCandidateModalityEnum = typeof HomeHealthCertificationEncounterCandidateModalityEnum[keyof typeof HomeHealthCertificationEncounterCandidateModalityEnum];


/**
 * Check if a given object implements the HomeHealthCertificationEncounterCandidate interface.
 */
export function instanceOfHomeHealthCertificationEncounterCandidate(value: object): value is HomeHealthCertificationEncounterCandidate {
    if (!('document_name' in value) || value['document_name'] === undefined) return false;
    if (!('encounter_date' in value) || value['encounter_date'] === undefined) return false;
    if (!('encounter_ref' in value) || value['encounter_ref'] === undefined) return false;
    if (!('signers' in value) || value['signers'] === undefined) return false;
    if (!('performer_type' in value) || value['performer_type'] === undefined) return false;
    if (!('setting' in value) || value['setting'] === undefined) return false;
    if (!('modality' in value) || value['modality'] === undefined) return false;
    if (!('related_to_hh_reason' in value) || value['related_to_hh_reason'] === undefined) return false;
    if (!('signed' in value) || value['signed'] === undefined) return false;
    if (!('clinical_support' in value) || value['clinical_support'] === undefined) return false;
    return true;
}

export function HomeHealthCertificationEncounterCandidateFromJSON(json: any): HomeHealthCertificationEncounterCandidate {
    return HomeHealthCertificationEncounterCandidateFromJSONTyped(json, false);
}

export function HomeHealthCertificationEncounterCandidateFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthCertificationEncounterCandidate {
    if (json == null) {
        return json;
    }
    return {
        
        'document_name': json['document_name'],
        'encounter_date': json['encounter_date'],
        'encounter_ref': ((json['encounter_ref'] as Array<any>).map(HomeHealthCertificationReferenceFromJSON)),
        'signers': ((json['signers'] as Array<any>).map(HomeHealthCertificationSignerFromJSON)),
        'performer_type': json['performer_type'],
        'setting': json['setting'],
        'modality': json['modality'],
        'related_to_hh_reason': HomeHealthCertificationAttestationFromJSON(json['related_to_hh_reason']),
        'signed': HomeHealthCertificationAttestationFromJSON(json['signed']),
        'clinical_support': HomeHealthCertificationEvidenceFromJSON(json['clinical_support']),
    };
}

export function HomeHealthCertificationEncounterCandidateToJSON(json: any): HomeHealthCertificationEncounterCandidate {
    return HomeHealthCertificationEncounterCandidateToJSONTyped(json, false);
}

export function HomeHealthCertificationEncounterCandidateToJSONTyped(value?: HomeHealthCertificationEncounterCandidate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'document_name': value['document_name'],
        'encounter_date': value['encounter_date'],
        'encounter_ref': ((value['encounter_ref'] as Array<any>).map(HomeHealthCertificationReferenceToJSON)),
        'signers': ((value['signers'] as Array<any>).map(HomeHealthCertificationSignerToJSON)),
        'performer_type': value['performer_type'],
        'setting': value['setting'],
        'modality': value['modality'],
        'related_to_hh_reason': HomeHealthCertificationAttestationToJSON(value['related_to_hh_reason']),
        'signed': HomeHealthCertificationAttestationToJSON(value['signed']),
        'clinical_support': HomeHealthCertificationEvidenceToJSON(value['clinical_support']),
    };
}

